{
  "gps": {
    "title": "Rastreamento GPS",
    "liveTracking": "Rastreamento ao Vivo",
    "geofences": "Geocercas",
    "reports": "Relatórios",
    "alerts": "Alertas",
    "soon": "Breve",
    "comingSoon": "Em Breve",
    "reportsComingSoon": "Relatórios em Breve",
    "reportsComingSoonMessage": "Estamos trabalhando em relatórios de viagens, histórico de rotas e análises. Fique ligado!",
    "alertsComingSoon": "Alertas em Breve",
    "alertsComingSoonMessage": "Alertas e notificações em tempo real estarão disponíveis em breve.",
    "geofencesComingSoon": "Geocercas em Breve",
    "geofencesComingSoonMessage": "Crie e gerencie limites geográficos para seus veículos.",
    
    "device": "Dispositivo",
    "devices": "Dispositivos",
    "devicesCount": "Dispositivos ({{count}})",
    "online": "Online",
    "offline": "Offline",
    "noLocationData": "Sem dados de localização",
    "speed": "Velocidade",
    "course": "Direção",
    "lastUpdate": "Última Atualização",
    "lastUpdated": "Última atualização",
    "coordinates": "Coordenadas",
    "deviceInfo": "Informações do Dispositivo",
    "imei": "IMEI",
    "makeModel": "Marca/Modelo",
    "noData": "Sem dados",
    "locationData": "Dados de Localização",
    
    "vehicle": "Veículo",
    "driver": "Motorista",
    "registration": "Matrícula",
    
    "geofence": "Geocerca",
    "createGeofence": "Criar Geocerca",
    "editGeofence": "Editar Geocerca",
    "deleteGeofence": "Excluir Geocerca",
    "geofenceName": "Nome da Geocerca",
    "description": "Descrição",
    "color": "Cor",
    "active": "Ativa",
    "inactive": "Inativa",
    "polygon": "Polígono",
    "circle": "Círculo",
    
    "trip": "Viagem",
    "trips": "Viagens",
    "route": "Rota",
    "routes": "Rotas",
    "summary": "Resumo",
    "generateReport": "Gerar Relatório",
    "selectDateRange": "Selecionar Período",
    "selectDevice": "Selecionar Dispositivo",
    "distance": "Distância",
    "duration": "Duração",
    "averageSpeed": "Velocidade Média",
    "maxSpeed": "Velocidade Máxima",
    "startLocation": "Local de Início",
    "endLocation": "Local de Fim",
    "engineHours": "Horas de Motor",
    
    "alert": "Alerta",
    "alertType": "Tipo de Alerta",
    "acknowledge": "Reconhecer",
    "acknowledged": "Reconhecido",
    "unacknowledged": "Não Reconhecido",
    "allAlerts": "Todos os Alertas",
    
    "geofenceEnter": "Entrada em Geocerca",
    "geofenceExit": "Saída de Geocerca",
    "speedExceeded": "Velocidade Excedida",
    "deviceOffline": "Dispositivo Offline",
    "deviceOnline": "Dispositivo Online",
    "ignitionOn": "Ignição Ligada",
    "ignitionOff": "Ignição Desligada",
    "lowBattery": "Bateria Baixa",
    "sosAlarm": "Alarme SOS",
    
    "noLicense": "Sem Licença GPS",
    "noLicenseTitle": "Rastreamento GPS Não Disponível",
    "noLicenseMessage": "Sua empresa não possui licenças GPS ativas.",
    "noLicenseAction": "Por favor, adquira licenças GPS para acessar recursos de rastreamento em tempo real.",
    "viewPlans": "Ver Planos",
    "upgradeToPro": "Atualizar para Rastreamento GPS",
    "checkingAccess": "Verificando acesso GPS...",
    
    "connected": "Conectado",
    "disconnected": "Desconectado",
    "connecting": "Conectando",
    "reconnecting": "Reconectando",
    
  "searchDevices": "Buscar dispositivos, placas, marca/modelo...",
  "noDevicesFound": "Nenhum dispositivo encontrado",
  "tryDifferentSearch": "Tente um termo de busca diferente",
  "searchVehicles": "Buscar veículos por placa, marca, modelo...",
  "noVehiclesFound": "Nenhum veículo encontrado",
    
    "noDevices": "Nenhum Dispositivo GPS Ativo",
    "noDevicesMessage": "Os dispositivos aparecerão aqui quando começarem a relatar posições",
    "noGeofences": "Nenhuma Geocerca Criada",
    "noGeofencesMessage": "Toque em 'Criar' para adicionar sua primeira geocerca",
    "noReports": "Nenhum Relatório Gerado",
    "noReportsMessage": "Selecione um período e gere um relatório para ver os dados aqui",
    "noAlerts": "Nenhum Alerta",
    "noPendingAlerts": "Nenhum Alerta Pendente",
    "allAlertsAcknowledged": "Todos os alertas foram reconhecidos",
    
    "loading": "Carregando",
    "loadingGeofences": "Carregando geocercas...",
    "refreshing": "Atualizando",
    "syncing": "Sincronizando",
    "error": "Erro",
    "success": "Sucesso",
    "create": "Criar",
    "edit": "Editar",
    "delete": "Excluir",
    "save": "Salvar",
    "cancel": "Cancelar",
    "close": "Fechar",
    "refresh": "Atualizar",
    "filter": "Filtrar",
    
    "drawInstructions": "Toque no mapa para adicionar pontos ao seu polígono",
    "drawingMode": "Modo de Desenho",
    "completePolygon": "Completar Polígono",
    "cancelDrawing": "Cancelar",
    "minimumPoints": "Um polígono deve ter pelo menos 3 pontos",
    
    "geofenceCreated": "Geocerca criada com sucesso",
    "geofenceUpdated": "Geocerca atualizada com sucesso",
    "geofenceDeleted": "Geocerca excluída com sucesso",
    "confirmDelete": "Tem certeza de que deseja excluir esta geocerca?",
    
    "reportGenerated": "Relatório gerado com sucesso",
    "exportPDF": "Exportar para PDF",
    "exportCSV": "Exportar para CSV",
    
    "alertAcknowledged": "Alerta reconhecido com sucesso",
    "managedInAdmin": "As regras de alerta são gerenciadas no painel de administração do Django",
    
    "selectVehicle": "Selecionar Veículo",
    "noVehicleAssigned": "Nenhum veículo atribuído",
    "noVehicleLinked": "Nenhum veículo associado a este dispositivo",
    "vehicleAssigned": "Veículo atribuído com sucesso",
    "vehicleUnassigned": "Veículo removido com sucesso",
    "failedToAssignVehicle": "Falha ao atribuir veículo",
    "failedToUnassignVehicle": "Falha ao remover veículo",
    "failedToLoadVehicles": "Falha ao carregar veículos",
    "unassignVehicle": "Remover Veículo",
    "noVehiclesAvailable": "Nenhum veículo disponível",
    "linkToVehicle": "Associar ao Veículo",
    "linkVehicle": "Associar Veículo",
    "editVehicle": "Editar Veículo",
    "deviceNotFound": "Dispositivo não encontrado",
    "forceUpdate": "Forçar Atualização",
    "updating": "Atualizando...",
    "forceUpdateNote": "Sincroniza dados do dispositivo com o servidor",
    "deviceDataUpdated": "Dados do dispositivo atualizados com sucesso",
    "failedToUpdateDevice": "Falha ao atualizar dados do dispositivo",
    "vehicles": "Veículos",
    "loadingVehicles": "Carregando veículos...",
    "updatedAt": "Atualizado",
    "contractTitle": "Contrato de Uso GPS",
    "contractSummary": "Ao aceitar, você concorda com os termos de uso do rastreamento GPS (coleta de dados, responsabilidades e privacidade) conforme documentação legal.",
    "contractAccept": "Aceitar",
    "contractReject": "Cancelar",
    "contractAccepting": "Aceitando...",
    "contractAcceptError": "Falha ao aceitar o contrato.",
    "contractVersion": "Versão {{version}}, de {{date}}",
    "contractSummaryHeading": "Resumo antes do aceite",
    "contractFullHeading": "Contrato completo e Anexo A",
    "contractCopyRecipient": "A cópia do contrato em PDF será enviada para {{email}} depois que a Stripe confirmar o pagamento."
  }
}

